import { type QueryHookOptions, useQuery } from "@apollo/client";
import { SupportRequestAssigneesQuery } from "../graphql/queries";
import type { SupportRequestAssigneesQueryType } from "@/types/graphql/partner.generated";

export const useSupportRequestAssigneesQuery = (
  options?: QueryHookOptions<SupportRequestAssigneesQueryType>
) =>
  useQuery<SupportRequestAssigneesQueryType>(
    SupportRequestAssigneesQuery,
    options
  );
